/** Filters that can be applied throughout the application */
const possibleCustomerFilters = ['streaming', 'download', 'charts'];

const possibleFilters = [
  'country',
  'region',
  ...possibleCustomerFilters,
  'media',
  'release',
  'genre',
  'customRegion',
  'platform',
];

interface IConfig {
  amountOfItemsToCheck: number;
  amountOfItemsToCompareAgainst: number;
}

function getTrendOutlierRemovalConfig(period: string): IConfig {
  let config;

  switch (period) {
    case 'day': {
      config = {
        amountOfItemsToCheck: 6,
        amountOfItemsToCompareAgainst: 7,
      };

      break;
    }
    case 'week':
    case 'month':
    case 'year':
    default: {
      config = {
        amountOfItemsToCheck: 1,
        amountOfItemsToCompareAgainst: 3,
      };

      break;
    }
  }

  return config;
}

export {
  possibleCustomerFilters,
  possibleFilters,
  getTrendOutlierRemovalConfig,
};

export const MAX_LIMIT = 999;

export const MAX_COUNTRY_NAME = 14;

export const CUSTOM_USER_REGION_TYPE = 'Custom User Region';

export const SHOW_BELL_NOTIFICATION = false;
